// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinnerCircle-module_spinnerBox__SbzPa {
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    animation-name: spinnerCircle-module_PreloaderAnimation__WreCZ;
    animation-timing-function: linear;
    width: var(--size);
    height: var(--size);

    svg {
        width: var(--size);
        height: var(--size);
    }
}

@keyframes spinnerCircle-module_PreloaderAnimation__WreCZ {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/UI/Spinner/spinnerCircle.module.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,mCAAmC;IACnC,8DAAkC;IAClC,iCAAiC;IACjC,kBAAkB;IAClB,mBAAmB;;IAEnB;QACI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":[".spinnerBox {\n    animation-duration: 1.5s;\n    animation-iteration-count: infinite;\n    animation-name: PreloaderAnimation;\n    animation-timing-function: linear;\n    width: var(--size);\n    height: var(--size);\n\n    svg {\n        width: var(--size);\n        height: var(--size);\n    }\n}\n\n@keyframes PreloaderAnimation {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinnerBox": `spinnerCircle-module_spinnerBox__SbzPa`,
	"PreloaderAnimation": `spinnerCircle-module_PreloaderAnimation__WreCZ`
};
export default ___CSS_LOADER_EXPORT___;
